export class Option {

    public id: number;

    public optionId: number;

    public text: string;
}
